import React from "react"
import { AddServiceSection } from "./components/AddServiceSection"
import { PrestatereSection } from "./components/PrestatereSection"
import { PromotionsSection } from "./components/PromotionsSection"
import { ServicesList } from "./components/ServicesList"

export const ValidateServiceStep: React.FC = () => {
  return (
    <div
      style={{
        maxHeight: "calc(95vh - 250px)",
        minHeight: "calc(95vh - 250px)",
      }}
      className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-background"
    >
      {/* Colonne gauche - Ajouter un service et Promotions */}
      <div
        style={{
          maxHeight: "calc(95vh - 240px)",
          minHeight: "calc(95vh - 240px)",
        }}
        className="flex flex-col gap-4 overflow-y-auto bg-background"
      >
        <AddServiceSection />
        <PrestatereSection />
        <PromotionsSection />
      </div>

      {/* Colonne droite - Résumé des prestations */}
      <ServicesList />
    </div>
  )
}
